<template>
  <div class="contract container">
    <p>國外團體旅遊定型化契約書 (中華民國105年12月12日觀業字第1050922838號函修正)</p>
    <p><br></p>
    <p>（本契約審閱期間至少一日， 年 月 日由甲方攜回審閱）</p>
    <p><br></p>
    <p>立契約書人</p>
    <p>旅客（以下稱甲方）：</p>
    <p>姓名：<span class="font-bold text-blue text-xl">{{ travelerName }}</span>。等共____________________人</p>
    <p>緊急聯絡人：</p>
    <p>姓名：____________________。；與旅客關係：____________________。；</p>
    <p>電話：<span class="font-bold text-blue text-xl">{{ travelerPhone }}</span>。</p>
    <p>旅行業（以下稱乙方）：</p>
    <p>公司名稱：雄獅旅行社股份有限公司；負責人：王文傑；營業所：台北市石潭路151號9樓。</p>
    <p>甲乙雙方同意就本旅遊事項，依下列約定辦理。</p>
    <p><br></p>
    <p>第一條（國外旅遊之意義）</p>
    <p><br></p>
    <p>本契約所謂國外旅遊，係指到中華民國疆域以外其他國家或地區旅遊。</p>
    <p>赴中國大陸旅行者，準用本旅遊契約之約定。</p>
    <p><br></p>
    <p>第二條（適用之範圍及順序）</p>
    <p><br></p>
    <p>甲乙雙方關於本旅遊之權利義務，依本契約條款之約定定之；本契約中未約定者，適用中華民國有關法令之規定。</p>
    <p><br></p>
    <p>第三條（旅遊團名稱、旅遊行程及廣告責任）</p>
    <p><br></p>
    <p>一、 本旅遊團名稱為：</p>
    <p>二、 旅遊地區（國家、城市或觀光地點）：</p>
    <p>行程（啟程出發地點、回程之終止地點、日期、交通工具、住宿旅館、餐飲、遊覽、安排購物行程及其所附隨之服務說明）：</p>
    <p>與本契約有關之附件、廣告、宣傳文件、行程表或說明會之說明內容均視為本契約內容之一部分。乙方應確保廣告內容之真實，對甲方所負之義務不得低於廣告之內容。</p>
    <p>第一項記載得以所刊登之廣告、宣傳文件、行程表或說明會之說明內容代之。</p>
    <p>未記載第一項內容或記載之內容與刊登廣告、宣傳文件、行程表或說明會之說明記載不符者，以最有利於甲方之內容為準。</p>
    <p><br></p>
    <p>第三條（旅遊團名稱、旅遊行程及廣告責任）</p>
    <p><br></p>
    <p>一、 本旅遊團名稱為：</p>
    <p>二、 旅遊地區（國家、城市或觀光地點）：</p>
    <p>行程（啟程出發地點、回程之終止地點、日期、交通工具、住宿旅館、餐飲、遊覽、安排購物行程及其所附隨之服務說明）：</p>
    <p>與本契約有關之附件、廣告、宣傳文件、行程表或說明會之說明內容均視為本契約內容之一部分。乙方應確保廣告內容之真實，對甲方所負之義務不得低於廣告之內容。</p>
    <p>第一項記載得以所刊登之廣告、宣傳文件、行程表或說明會之說明內容代之。</p>
    <p>未記載第一項內容或記載之內容與刊登廣告、宣傳文件、行程表或說明會之說明記載不符者，以最有利於甲方之內容為準。</p>
    <p><br></p>
    <p>旅行業（以下稱乙方）：</p>
    <p>公司名稱：雄獅旅行社股份有限公司；負責人：王文傑；營業所：台北市石潭路151號9樓。</p>
    <p>甲乙雙方同意就本旅遊事項，依下列約定辦理。</p>
    <p><br></p>
    <p>第一條（國外旅遊之意義）</p>
    <p><br></p>
    <p>本契約所謂國外旅遊，係指到中華民國疆域以外其他國家或地區旅遊。</p>
    <p>赴中國大陸旅行者，準用本旅遊契約之約定。</p>
    <p><br></p>
    <p>第二條（適用之範圍及順序）</p>
    <p><br></p>
    <p>甲乙雙方關於本旅遊之權利義務，依本契約條款之約定定之；本契約中未約定者，適用中華民國有關法令之規定。</p>
    <p><br></p>
    <p>第三條（旅遊團名稱、旅遊行程及廣告責任）</p>
    <p><br></p>
    <p>一、 本旅遊團名稱為：</p>
    <p>二、 旅遊地區（國家、城市或觀光地點）：</p>
    <p>行程（啟程出發地點、回程之終止地點、日期、交通工具、住宿旅館、餐飲、遊覽、安排購物行程及其所附隨之服務說明）：</p>
    <p>與本契約有關之附件、廣告、宣傳文件、行程表或說明會之說明內容均視為本契約內容之一部分。乙方應確保廣告內容之真實，對甲方所負之義務不得低於廣告之內容。</p>
    <p>第一項記載得以所刊登之廣告、宣傳文件、行程表或說明會之說明內容代之。</p>
    <p>未記載第一項內容或記載之內容與刊登廣告、宣傳文件、行程表或說明會之說明記載不符者，以最有利於甲方之內容為準。</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'order/traveler'
    ]),
    travelerName: function () {
      return this['order/traveler'].firstName + ' ' + this['order/traveler'].lastName
    },
    travelerPhone: function () {
      return this['order/traveler'].phone
    }
  }
}
</script>

<style lang="sass" scoped>
  p
    @apply leading-xl
</style>
